import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Microsoft365GroupSearchResult } from '../../shared/models/generated/ziroModels';

@Injectable()
export class TeamsAutoAttendantsGroupSearchResource {
  private http = inject(HttpClient);

  search(tenantId: string, query: string): Observable<Microsoft365GroupSearchResult[]> {
    return this.http.get<Microsoft365GroupSearchResult[]>(
      `/services/microsoft/auto-attendant-management/tenants/${tenantId}/groups/search?q=${encodeURIComponent(query)}`,
    );
  }
}
